import { render, staticRenderFns } from "./PrepareStatistic.vue?vue&type=template&id=06cbacf8"
import script from "./PrepareStatistic.vue?vue&type=script&lang=js"
export * from "./PrepareStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports